import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
} & ComponentPropsWithoutRef<"h1" | "h2" | "h3" | "h4" | "h5" | "h6">;

export const Heading = ({
  className,
  level = 1,
  ...props
}: HeadingProps): ReactElement => {
  const Element: `h${typeof level}` = `h${level}`;

  return (
    <Element
      {...props}
      className={clsx(
        className,
        "text-2xl/8 font-semibold text-zinc-950 sm:text-xl/8 dark:text-white",
      )}
    />
  );
};
